var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTelephoneBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    rx: 22.5,
    fill: "#00916E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1654 23.1713C17.4967 28.8384 16.2107 22.2822 12.6014 25.8889C9.12182 29.3676 7.12191 30.0646 11.5306 34.472C12.0828 34.9158 15.5914 40.255 27.9219 27.9279C40.2539 15.5994 34.9177 12.0872 34.4738 11.5351C30.0545 7.11547 29.3696 9.12702 25.8899 12.6057C22.2806 16.214 28.8341 17.5042 23.1654 23.1713Z",
    fill: "#F2F9F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTelephoneBg);
export default __webpack_public_path__ + "static/media/icon-telephone-bg.13b9a0e4828a5c77cf53f6200cd7d31c.svg";
export { ForwardRef as ReactComponent };